const content = {
  hi: {
    nav: ['होम', 'हमारे बारे में', 'कार्यक्रम', 'गैलरी', 'समीक्षाएं', 'संपर्क'],
    navEnroll: 'दाखिला लें 🚀',

    heroBadge: '🌟 दहियावां का भरोसेमंद प्रीस्कूल',
    heroH1a: 'जहाँ छोटे',
    heroStar: 'सितारे',
    heroH1b: 'सीखते, खेलते और',
    heroShine: 'चमकते हैं',
    heroH1c: 'हर दिन!',
    heroP: '2–6 साल के बच्चों के लिए एक सुरक्षित, खुशहाल और मज़ेदार जगह, जहाँ बच्चे खेल-खेल में सीखते हैं और हर दिन कुछ नया खोजते हैं।',
    heroCTA: 'दाखिला लें 🚀',
    heroExplore: 'कार्यक्रम देखें',

    heroStat1: 'खुश बच्चे',
    heroStat2: 'मज़ेदार कार्यक्रम',
    heroStat3: 'अभिभावकों की रेटिंग',
    heroStat4: 'अनुभव के साल',

    heroBadge1: 'नया सत्र शुरू!',
    heroBadge1sub: 'दाखिला 2025–26',
    heroBadge2: '✅ सुरक्षित और भरोसेमंद',

    whyTitle: 'अभिभावक हमें क्यों पसंद करते हैं 💛',
    whyItems: [
      { icon: '🛡️', text: 'पूरी तरह सुरक्षित और देखभाल भरा वातावरण' },
      { icon: '👩‍🏫', text: 'अनुभवी और बच्चों से प्यार करने वाले शिक्षक' },
      { icon: '🎨', text: 'खेल-खेल में सीखने का मज़ेदार तरीका' },
      { icon: '💰', text: 'किफायती और साफ-सुथरी फीस' },
      { icon: '🌱', text: 'बच्चों का सम्पूर्ण विकास – दिमाग, शरीर और व्यवहार' },
    ],

    aboutTag: 'हमारे बारे में',
    aboutH2: 'जहाँ हर बच्चा खास बनता है',
    aboutP: 'Kids Play Hall दहियावां का एक खुशहाल और प्यारा प्रीस्कूल है, जहाँ बच्चे खेलते-खेलते सीखते हैं। यहाँ हम बच्चों को सुरक्षित, प्यार भरा और प्रेरणादायक माहौल देते हैं, जिससे वे आत्मविश्वासी बनें और हर दिन खुशी से आगे बढ़ें।',

    aboutSticker: ['🏆', 'विश्वसनीय', '2022 से'],

    missionTitle: 'हमारा मिशन',
    missionP: 'हर बच्चे को खेल और रचनात्मक गतिविधियों के जरिए सीखने और आगे बढ़ने का मौका देना।',

    visionTitle: 'हमारी दृष्टि',
    visionP: 'एक ऐसा भरोसेमंद प्रीस्कूल बनना जहाँ बच्चे खुश, आत्मविश्वासी और सफल बनें।',

    programsTag: 'हम क्या सिखाते हैं',
    programsTitle: 'हमारे कार्यक्रम',
    programsSub: 'सीखने, खेलने और बढ़ने के लिए मज़ेदार और संतुलित गतिविधियाँ।',

    programs: [
      { icon: '🎠', title: 'सॉफ्ट प्ले एरिया', desc: 'नरम और सुरक्षित जगह जहाँ बच्चे आराम से कूद-फांद कर खेल सकते हैं।' },
      { icon: '🏃', title: 'ऑब्स्टेकल कोर्स', desc: 'मज़ेदार चुनौतियाँ जो बच्चों की ताकत, संतुलन और आत्मविश्वास बढ़ाती हैं।' },
      { icon: '⚽', title: 'बॉल पिट', desc: 'रंग-बिरंगे बॉल पिट जो बच्चों की कल्पना और इंद्रिय विकास को बढ़ाते हैं।' },
      { icon: '📚', title: 'पहेलियाँ और अक्षर', desc: 'खेल-खेल में अक्षर और सोचने की क्षमता को बढ़ाने वाली गतिविधियाँ।' },
      { icon: '🤝', title: 'अच्छे संस्कार', desc: 'बच्चों को शेयर करना, दया और अच्छा व्यवहार सिखाना।' },
      { icon: '🎉', title: 'खेल-खेल में पढ़ाई', desc: 'मज़ेदार तरीके से पढ़ाई जिससे सीखना आसान और दिलचस्प बनता है।' },
    ],

    galleryTag: 'यादगार पल',
    galleryTitle: 'हमारी गैलरी',
    gallerySub: 'देखें बच्चों की मुस्कान, मस्ती और सीखने के खास पल।',

    reviewsTag: 'अभिभावकों की राय',
    reviewsTitle: 'माता-पिता क्या कहते हैं',
    reviewsOf: 'में से',
    reviewsCount: 'समीक्षाएं',

    contactTag: 'संपर्क करें',
    contactTitle: 'हमसे जुड़ें',
    contactSub: 'कोई सवाल है? हमें WhatsApp पर मैसेज करें!',

    formTitle: '💬 WhatsApp पर संदेश भेजें',
    formName: 'आपका नाम',
    formPhone: 'आपका फोन नंबर',
    formMsg: 'आपका संदेश (जैसे: मैं अपने बच्चे का दाखिला करवाना चाहता/चाहती हूँ...)',
    formBtn: 'मैसेज भेजें',

    findUs: 'हमें यहाँ पाएँ',
    hours: 'सोम–शनि: सुबह 8 बजे – शाम 5 बजे',

    footerTagline: 'एक सुरक्षित और मज़ेदार प्रीस्कूल जहाँ बच्चे खेलते, सीखते और आगे बढ़ते हैं।',
    footerAddress: 'माँ काली मंदिर के पास, दहियावाँ रोड, दहियावां, UP 212503',
    footerHours: 'सोम–शनि: सुबह 8 – शाम 5',

    quickLinks: 'त्वरित लिंक',
    followUs: 'हमें फॉलो करें',

    footerBottom: `© ${new Date().getFullYear()} Kids Play Hall. सर्वाधिकार सुरक्षित। ❤️ दहियावां में बना`,
    footerLinks: ['होम', 'हमारे बारे में', 'कार्यक्रम', 'गैलरी', 'समीक्षाएं', 'संपर्क'],
  },

  en: {
    nav: ['Home', 'About', 'Programs', 'Gallery', 'Reviews', 'Contact'],
    navEnroll: 'Enroll Now 🚀',

    heroBadge: '🌟 Best Preschool in Dahiyawan',
    heroH1a: 'Where Little',
    heroStar: 'Stars',
    heroH1b: 'Learn &',
    heroShine: 'Grow',
    heroH1c: 'Every Day!',
    heroP: 'A safe, happy, and fun place for kids aged 2–6 to play, learn, and grow with joy every day.',
    heroCTA: 'Enroll Now 🚀',
    heroExplore: 'View Programs',

    heroStat1: 'Happy Kids',
    heroStat2: 'Fun Programs',
    heroStat3: 'Parent Rating',
    heroStat4: 'Years of Care',

    heroBadge1: 'Admissions Open!',
    heroBadge1sub: 'Session 2025–26',
    heroBadge2: '✅ Safe & Trusted',

    whyTitle: 'Why Parents Love Us 💛',
    whyItems: [
      { icon: '🛡️', text: 'Safe and Caring Environment' },
      { icon: '👩‍🏫', text: 'Friendly & Experienced Teachers' },
      { icon: '🎨', text: 'Learning Through Play & Activities' },
      { icon: '💰', text: 'Affordable Fees with Full Transparency' },
      { icon: '🌱', text: 'Overall Growth – Mind, Body & Emotions' },
    ],

    aboutTag: 'About Us',
    aboutH2: 'A Happy Place for Every Child',
    aboutP: 'Kids Play Hall is a joyful preschool in Dahiyawan where children learn through play. We create a safe and loving space where kids explore, grow, and build confidence every day. Our teachers guide each child with care, making learning fun and meaningful.',

    aboutSticker: ['🏆', 'Trusted', 'Since 2022'],

    missionTitle: 'Our Mission',
    missionP: 'To help every child learn, grow, and shine through fun and creative activities.',

    visionTitle: 'Our Vision',
    visionP: 'To become a trusted preschool where children feel happy, confident, and ready for the future.',

    programsTag: 'What We Offer',
    programsTitle: 'Our Programs',
    programsSub: 'Fun and balanced activities for learning, playing, and growing.',

    programs: [
      { icon: '🎠', title: 'Soft Play Area', desc: 'Safe and soft play zones where kids can jump, climb, and enjoy without getting hurt.' },
      { icon: '🏃', title: 'Obstacle Course', desc: 'Fun challenges that improve strength, balance, and confidence.' },
      { icon: '⚽', title: 'Ball Pit', desc: 'Colorful ball pits that boost creativity and sensory skills.' },
      { icon: '📚', title: 'Puzzles & ABC', desc: 'Simple games and activities to help kids learn letters and thinking skills.' },
      { icon: '🤝', title: 'Good Habits', desc: 'Teaching kids kindness, sharing, and good manners in daily life.' },
      { icon: '🎉', title: 'Fun Learning', desc: 'Play-based learning that makes education easy and enjoyable.' },
    ],

    galleryTag: 'Memories',
    galleryTitle: 'Our Gallery',
    gallerySub: 'See the smiles, fun, and learning moments of our kids.',

    reviewsTag: 'Parents Feedback',
    reviewsTitle: 'What Parents Say',
    reviewsOf: 'out of',
    reviewsCount: 'reviews',

    contactTag: 'Contact Us',
    contactTitle: 'Get In Touch',
    contactSub: 'Have questions? Message us on WhatsApp anytime!',

    formTitle: '💬 Send WhatsApp Message',
    formName: 'Your Name',
    formPhone: 'Your Phone Number',
    formMsg: 'Your Message (e.g., I want to enroll my child...)',
    formBtn: 'Send Message',

    findUs: 'Find Us',
    hours: 'Mon–Sat: 8 AM – 5 PM',

    footerTagline: 'A safe and fun preschool where kids play, learn, and grow happily.',
    footerAddress: 'Near Maa Kali Mandir, Dahiyawan Rd, Holagarh, UP 212503',
    footerHours: 'Mon–Sat: 8 AM – 5 PM',

    quickLinks: 'Quick Links',
    followUs: 'Follow Us',

    footerBottom: `© ${new Date().getFullYear()} Kids Play Hall. All rights reserved. Made with ❤️ in Dahiyawan`,
    footerLinks: ['Home', 'About', 'Programs', 'Gallery', 'Reviews', 'Contact'],
  },
};

export default content;
